import React from "react"
import PropTypes from "prop-types"

import LoaderSection from '../app_components/LoaderSection'
import StandardButton from '../app_components/StandardButton'
import SentConnectRequests from './SentConnectRequests'
import ConnectRequests from './ConnectRequests'
import Connects from './Connects'
import SendConnectRequest from './SendConnectRequest'
import MissedConnects from './MissedConnects'
import CommunityExplore from './CommunityExplore'
import ConnectCircleHeader from './ConnectCircleHeader'
import {
  filterConnects,
  getLearningLanguageTabs,
} from './connectMemberHelpers'

function parseConnectPayload(value) {
  if (Array.isArray(value) || (value && typeof value === 'object')) {
    return value
  }
  return JSON.parse(value)
}

class ConnectDashboard extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      currentUser: {},
      connectedUsers: [],
      requestedConnects: [],
      dataLoaded: false,
      requestOpen: false,
      requestee_name: '',
      requestee_id: '',
      og_connection: false,
      ogConnectionsSent: [],
      sentConnectRequests: [],
      missedConnects: [],
      searchQuery: '',
      selectedLanguageKey: 'all',
    }

    this.closeRequest = this.closeRequest.bind(this)
    this.openRequest = this.openRequest.bind(this)
    this.updateOgConnectionNames = this.updateOgConnectionNames.bind(this)
    this.handleSearchChange = this.handleSearchChange.bind(this)
    this.handleLanguageSelect = this.handleLanguageSelect.bind(this)
  }

  componentDidMount() {
    $.ajax({
      url: `../getSentConnectData`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          sentConnectRequests: parseConnectPayload(data.data.sent_requests),
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    })
  }

  closeRequest() {
    this.setState({
      requestOpen: false,
      requestee_name: '',
      requestee_id: '',
      og_connection: false
    })
  }

  openRequest(name, id, og_connection) {
    window.scrollTo(0, 0)
    this.setState({
      requestOpen: true,
      requestee_name: name,
      requestee_id: id,
      og_connection: og_connection
    })
  }

  componentWillMount() {
    $.ajax({
      url: `../getUserConnectData`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          currentUser: parseConnectPayload(data.data.current_user),
          connectedUsers: parseConnectPayload(data.data.connected_users),
          requestedConnects: parseConnectPayload(data.data.requested_connects),
          missedConnects: parseConnectPayload(data.data.missed_connects),
          dataLoaded: true,
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    })
  }

  updateOgConnectionNames(name) {
    this.setState({
      ogConnectionsSent: [...this.state.ogConnectionsSent, name]
    })
  }

  handleSearchChange(searchQuery) {
    this.setState({ searchQuery })
  }

  handleLanguageSelect(selectedLanguageKey) {
    this.setState({ selectedLanguageKey })
  }

  getFilteredConnects() {
    const { connectedUsers, currentUser, searchQuery, selectedLanguageKey } = this.state
    if (!currentUser.id) return connectedUsers

    return filterConnects(connectedUsers, currentUser.id, {
      searchQuery,
      languageKey: selectedLanguageKey,
    })
  }

  renderMyConnects() {
    const { connectedUsers, currentUser } = this.state
    const count = connectedUsers.length
    const filteredConnects = this.getFilteredConnects()
    const languageTabs = getLearningLanguageTabs(
      currentUser.languages_users,
      connectedUsers,
      currentUser.id,
    )

    if (connectedUsers.length === 0) {
      return (
        <section className="connectsSection">
          <ConnectCircleHeader
            connectCount={0}
            worldImageUrl={this.props.worldImage}
            searchQuery={this.state.searchQuery}
            onSearchChange={this.handleSearchChange}
            languageTabs={languageTabs}
            selectedLanguageKey={this.state.selectedLanguageKey}
            onLanguageSelect={this.handleLanguageSelect}
          />
          <div className="connectsEmpty">
            <p className="connectsEmpty__text">
              You don't have any <strong>Connects</strong> yet — but the community is buzzing. Find your first partner below!
            </p>
            <div className="friendsIllustration" onClick={() => window.location.assign('/friends')} role="presentation" />
          </div>
          <div className="connectsCta connectsCta--inSection">
            <StandardButton
              text="Find New Connects"
              size="large"
              primary={true}
              icon="rocket"
              iconSolid={true}
              fullWidth={true}
              onClick={() => window.location.assign('/friends')}
            />
          </div>
        </section>
      )
    }

    return (
      <section className="connectsSection">
        <ConnectCircleHeader
          connectCount={count}
          worldImageUrl={this.props.worldImage}
          searchQuery={this.state.searchQuery}
          onSearchChange={this.handleSearchChange}
          languageTabs={languageTabs}
          selectedLanguageKey={this.state.selectedLanguageKey}
          onLanguageSelect={this.handleLanguageSelect}
        />
        {filteredConnects.length > 0 ? (
          <Connects
            missingImg={this.props.missingImg}
            currentUserId={currentUser.id}
            connectedUsers={filteredConnects}
            premiumUser={this.props.premiumUser}
          />
        ) : (
          <div className="connectsEmpty connectsEmpty--filtered">
            <p className="connectsEmpty__text">No friends match your search.</p>
          </div>
        )}
        <div className="connectsCta connectsCta--inSection">
          <StandardButton
            text="Find New Connects"
            size="large"
            primary={true}
            icon="rocket"
            iconSolid={true}
            fullWidth={true}
            onClick={() => window.location.assign('/friends')}
          />
        </div>
      </section>
    )
  }

  render() {
    if (!this.state.dataLoaded) {
      return <LoaderSection />
    }

    return(
      <div className="connectsPage">
        {this.state.requestOpen &&
          <SendConnectRequest
            requestee_id={this.state.requestee_id}
            requestee_name={this.state.requestee_name}
            closeRequest={this.closeRequest}
            openRequest={this.openRequest}
            og_connection={this.state.og_connection}
            updateOgConnectionNames={this.updateOgConnectionNames}
          />}

        {this.state.requestedConnects.length > 0 &&
          <ConnectRequests requestedConnects={this.state.requestedConnects} />}

        {this.renderMyConnects()}

        {this.state.missedConnects.length > 0 &&
          <MissedConnects
            missingImg={this.props.missingImg}
            missedConnects={this.state.missedConnects}
          />}

        {this.state.sentConnectRequests.length > 0 &&
          <SentConnectRequests
            missingImg={this.props.missingImg}
            requestedConnects={this.state.sentConnectRequests}
          />}

        <CommunityExplore
          missingImg={this.props.missingImg}
          newestUsers={this.props.newestUsers}
          onlineUsers={this.props.onlineUsers}
        />
      </div>
    )
  }
}

ConnectDashboard.propTypes = {
  missingImg: PropTypes.string.isRequired,
  worldImage: PropTypes.string,
  premiumUser: PropTypes.bool,
  newestUsers: PropTypes.array,
  onlineUsers: PropTypes.array,
}

export default ConnectDashboard
